import AssetAlerts from './AssetAlerts';

export default AssetAlerts;
export { AssetAlerts };
